module.exports = "<div class=\"applied-filter-box\" *ngIf=\"filters.length > 0\">\n    <div class=\"applied-filter-label\" *ngFor=\"let filter of filters\">\n        {{ filter }}\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/modules/mobile/components/applied-filters/m-applied-filters.component.html
// module id = ../../../../../angular/app/modules/mobile/components/applied-filters/m-applied-filters.component.html
// module chunks = main